<div [id]="'tripPlanPrint-' + tripId">
  <div class="title" style="font-size: 16px; font-weight: 700;margin: 18px 0">{{ tripName }}</div>
  @if (itineraryItems) {
    <div class="items">
      @for (itineraryItem of itineraryItems; let i = $index; let last = $last; track i) {
        <div class="item">
          <div class="table">
            @if (i === 0) {
              <div class="thead">
                <div class="tr" style="display: flex">
                  <div class="th" style="padding: 15px 10px;width: 50px">N</div>
                  <div class="th" style="padding: 15px 10px;width: 40%">City name</div>
                  <div class="th" style="padding: 15px 10px;width: 40%">Date</div>
                  <div class="th" style="padding: 15px 10px;width: 20%">Nights</div>
                </div>
              </div>
            }
            <div class="tbody" style="border: 1px solid #E1E1E1;border-radius: 8px">
              <div class="tr" style="display: flex">
                <div class="td" style="padding: 15px 10px;width: 50px">{{ i + 1 }}.</div>
                <div class="td" style="padding: 15px 10px;width: 40%">{{ itineraryItem.name }}</div>
                <div class="td" style="padding: 15px 10px;width: 40%">
                  @if (isValidDate(itineraryItem?.dates.from)) {
                    {{ formatDate(itineraryItem.dates.from) }} - {{ formatDate(itineraryItem.dates.to) }}
                  }
                </div>
                <div class="td" style="padding: 15px 10px;width: 20%">{{ itineraryItem.days }} nights</div>
              </div>

              @if (itineraryItem?.stopovers.length) {
                <div class="tr tr--no-border">
                  <p class="en-route"
                     style="color: black;padding: 14px 8px 6px;font-size: 12px;font-weight: 700;line-height: 20px; border-top: 1px solid #E1E1E1">
                    En-route: Attaractions on the way.
                  </p>
                </div>

                @for (stopover of itineraryItem.stopovers; let j = $index; track j) {
                  <div class="tr" style="display: flex" [style.border-top]="j !== 0 ? '1px solid #E1E1E1' : ''">
                    <div class="td" style="padding: 10px;width: 50px">{{ i + 1 }}.{{ j + 1 }}</div>
                    <div class="td" style="padding: 10px;width: 40%">{{ stopover.name }}</div>
                    <div class="td" style="padding: 10px;width: 40%"></div>
                    <div class="td" style="padding: 10px;width: 20%"></div>
                  </div>
                }
              }
            </div>
          </div>
          <div style="width: 100%; height: 16px"></div>
        </div>
      }
    </div>
  }
</div>
